import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { union } from 'lodash';
import { Redirect } from 'react-router-dom';

import TitleWithShape from 'components/TitleWithShape';
import IconButton from 'components/IconButton';
import BackButton from 'components/BackButton';

const INFORS = [
  {
    title: 'Administrative appeals',
    icon: 'icon34',
  },
  {
    title: 'Admiralty and aviation',
    icon: 'icon33',
  },
  {
    title: 'Bankruptcy and insolvency',
    icon: 'icon32',
  },
  {
    title: 'Contracts',
    icon: 'icon31',
  },
  {
    title: 'Conveyancing',
    icon: 'conveyancing',
  },
  {
    title: 'Corporate structure',
    icon: 'icon30',
  },
  {
    title: 'Crime',
    icon: 'crime',
  },
  {
    title: 'Debt collection',
    icon: 'icon29',
  },
  {
    title: 'Employment',
    icon: 'icon28',
  },
  {
    title: 'Family',
    icon: 'icon27',
  },
  {
    title: 'Food act and liquor licencing',
    icon: 'icon26',
  },
  {
    title: 'Franchise',
    icon: 'icon25',
  },
  {
    title: 'Fraud',
    icon: 'icon24',
  },
  {
    title: 'Immigration',
    icon: 'icon23',
  },
  {
    title: 'Insurance',
    icon: 'icon22',
  },
  {
    title: 'Intellectual property',
    icon: 'icon21',
  },
  {
    title: 'Internal disputes',
    icon: 'icon20',
  },
  {
    title: 'Leasing',
    icon: 'icon19',
  },
  {
    title: 'Misleading and deceptive conduct',
    icon: 'icon18',
  },
  {
    title: 'Mortgages and securities',
    icon: 'icon17',
  },
  {
    title: 'Motor vehicle',
    icon: 'icon16',
  },
  {
    title: 'Neighbourhood disputes',
    icon: 'icon15',
  },
  {
    title: 'Personal injury',
    icon: 'icon14',
  },
  {
    title: 'Planning and environment',
    icon: 'icon13',
  },
  {
    title: 'Professional discipline',
    icon: 'icon12',
  },
  {
    title: 'Professional negligence',
    icon: 'icon11',
  },
  {
    title: 'Property and business',
    icon: 'icon10',
  },
  {
    title: 'Property development',
    icon: 'property-development',
  },
  {
    title: 'Taxation and superannuation',
    icon: 'icon9',
  },
  {
    title: 'Wills and estate planning',
    icon: 'icon8',
  },
  {
    title: 'Unsure',
    icon: 'unsure',
  },
  /* Invisble tile to keep grid */
  {
    title: 'hidden',
    icon: 'unsure',
    invisible: true,
  },
];

const Wrapper = styled.div`
  color: #35447d;
  margin: 7.1rem 5.4rem;
  background: #f8f7f3;
  .bar-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 3rem;
    padding-right: 3.7rem;
    padding-left: 3.7rem;
  }
  .form-title {
    margin-top: 6.2rem;
    margin-left: 10.3rem;
  }
  .content {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    padding: 5.2rem 16rem 2.3rem 6.9rem;
  }

  .button-wrapper {
    padding-bottom: 7rem;
    padding-right: 12.3rem;
    display: flex;
    justify-content: flex-end;
  }

  @media only screen and (max-width: 1400px) {
    .content {
      padding-left: 5rem;
      padding-right: 5rem;
    }
  }

  @media only screen and (max-width: 768px) {
    margin: auto;

    .content {
      padding: 0;
    }

    .button-wrapper {
      margin-top: 5rem;
    }
  }
`;

class Step3 extends Component {
  constructor(props) {
    super(props);
    this.state = props.formData;
    // Set defaults
    this.state.selectedMatters = this.state.selectedMatters || [];
    this.state.redirect = false;
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleButtonClick = (selectedMatter) => {
    const newMatters = this.state.selectedMatters.slice(0);
    const index = newMatters.map(matter => matter.title).indexOf(selectedMatter.title);
    if (index !== -1) {
      newMatters.splice(index, 1);
    } else {
      newMatters.push(selectedMatter);
    }

    if (newMatters.length > 3) {
      return;
    }

    this.setState({ selectedMatters: union(newMatters) });
  }

  nextFormPage() {
    this.setState({ completed: true }, () => {
      this.props.collectData('step3', this.state);
      this.setState({ redirect: '/get-started/step-four' });
    });
  }

  render() {
    const { selectedMatters } = this.state;

    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} push />;
    }

    return (
      <Wrapper>
        <div className="bar-wrapper">
          <BackButton />
        </div>
        <div className="form-title">
          <TitleWithShape
            title={<p>Matter type <span className="small"> - Select up to three</span></p>}
          />
        </div>
        <div className="content">
          {
            INFORS.map((info, i) =>
              (<IconButton
                key={i}
                name={info.title}
                icon={info.icon}
                invisible={info.invisible ? info.invisible : false}
                background="transparent"
                width={26}
                height={9}
                rightMargin={2}
                topMargin={2}
                selected={selectedMatters.map(matter => matter.title).indexOf(info.title) !== -1}
                onClick={() => this.handleButtonClick(info)}
                uppercase
              />))
          }
        </div>
        <div className="button-wrapper">
          <IconButton
            name="Save and continue"
            icon="downArrow"
            onClick={() => this.nextFormPage()}
            selected
            noBorder
          />
        </div>
      </Wrapper>
    );
  }
}

Step3.propTypes = {
  collectData: PropTypes.func.isRequired,
  formData: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default Step3;



// WEBPACK FOOTER //
// ./src/containers/BeginPage/Step3.js